module.exports = __webpack_public_path__ + "static/media/image2.f2238dd9.JPG";